import React from "react";
import { Badge, Box, Divider, Typography } from "@mui/material";

import { useBaseTabsContext } from "../BaseTabs";
import { useBaseTabPanelContext } from "./BaseTabPanel";

import { getMuiIcon } from "utils";
import { BASE_CONSTANTS } from "constants/baseConstants";
import BaseCheckbox from "./BaseCheckbox";

export const PanelHeader = ({ children, label }) => {
  const { activeTabDetail } = useBaseTabsContext();

  const { state, onSelectAll } = useBaseTabPanelContext();

  const allItemSelected = React.useMemo(
    () =>
      !!(
        state.availableItems?.length &&
        state.availableItems?.every((item) =>
          state.selectedItems.includes(item)
        )
      ),
    [state.availableItems, state.selectedItems]
  );

  const renderIcon = React.useMemo(() => {
    if (activeTabDetail?.multiSelect)
      return (
        <BaseCheckbox
          size="small"
          indeterminate={!!state?.selectedItems?.length && !allItemSelected}
          checked={allItemSelected}
          onClick={onSelectAll}
        />
      );

    if (!activeTabDetail?.icon) return null;

    return (
      <Badge badgeContent={activeTabDetail?.badgeContent} color="primary">
        {getMuiIcon(activeTabDetail?.icon, {
          color: "action",
        })}
      </Badge>
    );
  }, [
    activeTabDetail?.badgeContent,
    activeTabDetail?.icon,
    activeTabDetail?.multiSelect,
    allItemSelected,
    onSelectAll,
    state?.selectedItems?.length,
  ]);

  return (
    <>
      <Box padding={BASE_CONSTANTS.PADDING_MD}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box
            display="inline-flex"
            alignItems="center"
            justifyContent="space-between"
            gap={BASE_CONSTANTS.SPACING_SM}
          >
            {renderIcon}

            <Typography style={{ fontWeight: 500 }}>
              {label ?? activeTabDetail?.label}
            </Typography>
          </Box>

          {children}
        </Box>

        {!!state.selectedItems.length && (
          <div className="-mb-2 ml-14 mt-2 text-xs text-gray-500">
            {state.selectedItems?.length} items selected
          </div>
        )}
      </Box>

      <Divider />
    </>
  );
};
